import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, Home } from 'lucide-react';

const AdminHeader = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <header className="glass-effect border-b border-white/10 px-4 md:px-8 py-4">
      <div className="max-w-[1400px] mx-auto flex justify-between items-center gap-2">
        <Link to="/admin" className="group">
          <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-purple-600 font-['Poppins'] text-sm md:text-2xl font-bold tracking-tight whitespace-nowrap">
            ADMIN PANEL
          </h1>
          <p className="text-gray-400 text-[7px] md:text-[12.8px] tracking-tight mt-1 font-light whitespace-nowrap">
            Content Management System
          </p>
        </Link>

        <div className="flex items-center gap-1 md:gap-4">
          <Link
            to="/"
            className="flex items-center gap-1 text-gray-400 hover:text-white transition-colors"
          >
            <Home size={16} className="md:w-5 md:h-5" />
            <span className="text-[10px] md:text-sm whitespace-nowrap">View Site</span>
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center gap-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-2 md:px-4 py-1.5 md:py-2 rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all shadow-lg shadow-purple-500/30"
          >
            <LogOut size={16} className="md:w-5 md:h-5" />
            <span className="text-[10px] md:text-base">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;